module.exports = __webpack_public_path__ + "static/sell-first-55effc3a6e5ec195dde819c3d99a249d.png";